// extracted by mini-css-extract-plugin
export default {"container":"PercentageBar_container__5+DRS","label":"PercentageBar_label__jUOUj"};